import FormPaperLayout from "./FormPaperLayout";
export default FormPaperLayout;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/FormPaperLayout/index.tsx